<script lang="ts">
    import { onDestroy } from 'svelte';
    import Regex from '../../lib/regex';

    export let name: string;
    export let errors: Record<string, string[]>;
    export let label: string = '';
    export let value: string = '';
    export let placeholder: string = 'hostname.local';
    export let disabled: boolean = false;
    export let required: boolean = false;

    errors[name] = [];

    const validate = (val: string = value) => {
        errors[name] = [];
        if (required && !val.trim()) {
            errors[name].push('This field is required');
        } else if (val && !Regex.Hostname.test(val)) {
            errors[name].push('Invalid hostname or domain');
        }
    };
    validate();

    const handleInput = (e: Event) => {
        value = (e.currentTarget as HTMLInputElement).value;
        validate(value);
    };

    onDestroy(() => { errors[name] = []; });
</script>

<label class="form-field">
    {#if label}<span class="label-text">{label}</span>{/if}
    <input
        type="text"
        {name}
        {disabled}
        {required}
        {placeholder}
        value={value}
        on:input={handleInput}
        class:error={errors[name].length > 0}
        on:change
        on:blur
    />
    <span class="field-errors">
        {#each errors[name] as err}<span>{err}</span>{/each}
    </span>
</label>
